import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllClientes, getClienteId } from "../../../redux/clientes/clientesAction";
import Select from "react-select";
import {customStylesCliente} from './selectArticulos'

const ClienteInput = forwardRef(({ onClienteChange, clienteRegular }, ref) => {
    const dispatch = useDispatch();
    
    const clientes = useSelector((state) => state.clientes.allClientes);
    console.log(clientes); 
    console.log(clienteRegular);
    
    
    const [cliente, setCliente] = useState({
        nombre:"",
        ciudad:"",
        direccion:"",
        cp:"",
        zona:"",
        telefono:"",
        notas:"",
        cuitCuilDni:""
    })

    useEffect(() => {
        onClienteChange(cliente)
    }, [cliente]);

    useEffect(() => {
        dispatch(getAllClientes());
    }, []);

    useEffect(() => {
        if(!clienteRegular){
            cleanCliente();
        }
    }, [clienteRegular]);

    const handleChange = (e) => {
        const {name, value} = e.target;
        //console.log(name, value);
        
        setCliente({
            ...cliente,
            [name]: value
        });
    };

    useImperativeHandle(ref, () => ({
        resetCliente(){
            setCliente({
            nombre:"",
            ciudad:"",
            direccion:"",
            cp:"",
            zona:"",
            telefono:"",
            notas:"",
            cuitCuilDni:""
        });
            onClienteChange({
                nombre:"",
                ciudad:"",
                direccion:"",
                cp:"",
                zona:"",
                telefono:"",
                notas:"",
                cuitCuilDni:""
            });
        }
       
    }));

    const options = [
        {value:"", label:"Select...", numCliente:"Select..."},
        ...clientes.map(e => ({
        label: `${e.nombre}`,
        value: e._id,
        numCliente: e.numCliente 
      }))
    ];

    const CustomDropdownIndicator = () => null; //saca la flecha del select

    const findCliente = (e) => {
        console.log("find cliente");
        console.log(e)

        const foundCliente = clientes.find(x => x._id === e.value)
        console.log(foundCliente);
        
        setCliente({
            ...cliente,
            id: foundCliente._id,
            numCliente: foundCliente.numCliente,
            nombre: foundCliente.nombre,
            ciudad: foundCliente.ciudad,
            direccion: foundCliente.direccion,
            cp: foundCliente.cp,
            zona: foundCliente.zona,
            telefono: foundCliente.telefono,
            notas: foundCliente.notas,
            cuitCuilDni: foundCliente.cuitCuilDni
        })
    }

    console.log(cliente);

    const cleanCliente = () => {
        setCliente({
            ...cliente,
            id: "",
            numCliente: "",
            nombre: "",
            ciudad: "",
            direccion: "",
            cp: "",
            zona: "",
            telefono: "",
            notas: "",
            cuitCuilDni: ""
        })
    }
    


    return (
        <>
            <div className="h-[100px] text-[10pt]">
            { clienteRegular &&
            <div className="mb-2">
                <Select                           
                                styles={customStylesCliente()}
                                //value={(options.find(option => option.value === cliente.id))}   
                                onChange={findCliente}                                
                                options={options}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                formatOptionLabel={(option, { context }) => context === 'menu' ? option.label : option.label}
                                components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: null }}                                   
                                //isClearable={true}                            
                            />
            </div>
            }
            <div className="flex w-[1180px] mb-2 ">                
            <label className="block w-[70px] font-bold">Nombre</label>
            <input
                className="w-[500px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="nombre"
                value={cliente.nombre}
                onChange={handleChange}
            />            
            <label className="block w-[100px] ml-[100px] font-bold">Cuit/Cuil/DNI</label>
            <input
                className="rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="cuitCuilDni"
                value={cliente.cuitCuilDni}
                onChange={handleChange}
            />           
            </div>
            <div className="flex w-[1180px] mb-2">
            <label className="block w-[70px] font-bold">Ciudad</label>
            <input
                className="w-[250px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="ciudad"
                value={cliente.ciudad}
                onChange={handleChange}
            />
            <label className="block w-[70px] ml-[20px] font-bold">Direccion</label>
            <input
                className="w-[400px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="direccion"
                value={cliente.direccion}
                onChange={handleChange}
            />
            <label className="block w-[30px] ml-[20px] font-bold">CP</label>
            <input
                className="w-[80px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="cp"
                value={cliente.cp}
                onChange={handleChange}
            />
            { !clienteRegular ?
            <>
            <label className="block w-[40px] ml-[20px] font-bold">Zona</label>
            <select
                className="w-[100px] rounded border bg-slate-300 text-black font-semibold text-center"
                type="text"
                name="zona"
                value={cliente.zona}
                onChange={handleChange}                
            >
                <option value="">Elegir Zona</option>
                <option value="CABA">CABA</option>
                <option value="Norte">Norte</option>
                <option value="Oeste">Oeste</option>
                <option value="Sur">Sur</option>
            </select>
            </>
            :
            <label className="flex w-[40px] ml-[20px] font-bold">Zona: <p className="ml-1">{cliente.zona}</p></label>
            }
            </div>
            <div className="flex">
            <label className="block w-[70px] font-bold">Telefono</label>
            <input
                className="w-[250px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="telefono"
                value={cliente.telefono}
                onChange={handleChange}
            />
            <label className="w-[50px] ml-[20px] font-bold">Notas</label>
            <input
                className="w-[600px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="notas"
                value={cliente.notas}
                onChange={handleChange}
            />
            </div>
            </div>
        </>
    )
})

export default ClienteInput;